import debounce from 'es6-promise-debounce'
import fobclient from '@/fobclient'
import { ToastError } from '@/utils'
import store from '@/store'

export const fetchList = (route, page, size, sort, sortOrder, filter) => {
  let sortString
  if (sort) {
    sortString = `${sort},${sortOrder}`
  } else {
    sortString = 'id,desc'
  }
  const params = {
    projection: 'list',
    page,
    size,
    sort: sortString,
    ...filter
  }

  return new Promise((resolve, reject) => {
    fobclient.find[route].withGenericAnd(params).then(({ data, meta }) => {
      resolve({data, meta})
    }).catch((error) => {
      store.dispatch('resetLoading')
      ToastError(error, 5000, {
        route,
        page,
        size,
        sort,
        sortOrder,
        sortString,
        filter
      })
      reject()
    })
  })
}

export const find = (entity, searchMethod, orderBy) => {
  return new Promise((resolve, reject) => {
    let params = { size: 500 }
    if (orderBy != null) {
      params.sort = orderBy
    }
    fobclient.find[entity].bySearchRepLike('', params).then(async ({ data, meta }) => {
      resolve({data, meta})
    }).catch((error) => {
      store.dispatch('resetLoading')
      ToastError(error, 5000, {
        entity,
        searchMethod
      })
      reject()
    })
  })
}

export const fetchResource = (entity, id) => {
  return new Promise((resolve, reject) => {
    fobclient.find[entity].byID(id)
    .then(async (entity) => {
      await entity.fetchResource()
      resolve(entity)
    }).catch((error) => {
      store.dispatch('resetLoading')
      ToastError(error, 5000, {
        entity,
        id
      })
      reject()
    })
  })
}

// TODO: What returns genricSave
export const saveResource = (route, data) => {
  return fobclient.genericSave(route)(data)
}

export const updaveResource = (entity) => {
  return new Promise((resolve, reject) => {
    fobclient.updaveEntity(entity).then((data) => {
      resolve(data)
    }).catch((error) => {
      store.dispatch('resetLoading')
      ToastError(error, 5000, {
        entity
      })
      reject()
    })
  })
}

const autocompleteUnbounced = (route, method) => query => {
  return new Promise((resolve, reject) => {
    fobclient.find[route][method]({ ...query, size: 200, page: 0 }).then((data) => {
      resolve(data)
    }).catch((error) => {
      store.dispatch('resetLoading')
      ToastError(error, 10000, {
        method,
        route,
        query,
        error: error.response.data.error,
        status: error.response.data.status,
        path: error.response.data.path,
        timestamp: error.response.data.timestamp,
        exception: error.response.data.exception
      })
      reject()
    })
  })
}

export const autocomplete = (route, method) => {
  return debounce(
    autocompleteUnbounced(route, method),
    500
  )
}

export const deleteEntity = (entity) => {
  return fobclient.deleteEntity(entity)
}



// WEBPACK FOOTER //
// ./src/api/methods.js